import React from 'react'
import { useAppAction, useAppSelect } from 'src/hooks/useApp'
import { NavItem } from '../NavItem'

import Stack from '@mui/material/Stack'
import SwitchTransition from 'react-transition-group/SwitchTransition'
import Fade from '@mui/material/Fade'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

import { SchemeListSkeleton } from '../VerticalNavItems'
import UserIcon from 'src/components/ui/UserIcon'
import { useTranslation } from 'react-i18next'

const SchemesAdminListNavigation = () => {
  const { t } = useTranslation('common')
  const getAdminSchemesAction = useAppAction.getAdminSchemas()
  const getAdminSchemesActionStatus = useAppAction.getAdminSchemas.status()

  const schemasAdminData = useAppSelect.schemasAdmin()
  const loadMoreAdminSchemesAction = useAppAction.loadMoreAdminSchemas()
  const loadMoreAdminSchemesActionStatus =
    useAppAction.loadMoreAdminSchemas.status()

  const handleFetchMoreSchemes = () => {
    if (schemasAdminData.cursor) {
      loadMoreAdminSchemesAction({
        cursor: schemasAdminData.cursor,
        perPage: 20,
      })
    }
  }

  React.useEffect(() => {
    if (getAdminSchemesActionStatus.isClear) {
      getAdminSchemesAction({ perPage: 20 })
    }
  }, [getAdminSchemesActionStatus.isClear])

  const showFetchMoreButton =
    schemasAdminData.cursor && !getAdminSchemesActionStatus.isPending

  return (
    <Stack direction="column">
      <SwitchTransition mode="out-in">
        <Fade
          key={getAdminSchemesActionStatus.isPending ? 'loader' : 'content'}
          timeout={{ exit: 0, enter: 300 }}
          unmountOnExit
        >
          {getAdminSchemesActionStatus.isPending ? (
            <Stack pl={5}>
              <SchemeListSkeleton count={10} />
            </Stack>
          ) : (
            <Stack direction="column">
              {getAdminSchemesActionStatus.isFulfilled &&
                schemasAdminData.items.map((scheme) => (
                  <NavItem
                    key={scheme.identifier}
                    title={scheme.title}
                    deep={2}
                    icon={
                      <UserIcon
                        color="inherit"
                        fontSize={24}
                        icon="tabler-table"
                      />
                    }
                    permission={['storage.objectScheme.store']}
                  >
                    <NavItem
                      title={'Group'}
                      icon={
                        <UserIcon
                          color="inherit"
                          fontSize={24}
                          icon="material-symbols:folder"
                        />
                      }
                      path={`/admin/groups/${scheme.identifier}`}
                      deep={3}
                      permission={'storage.objectScheme.store'}
                    />
                    <NavItem
                      title={'Fields'}
                      icon={
                        <UserIcon
                          color="inherit"
                          fontSize={24}
                          icon="material-symbols-light:input"
                        />
                      }
                      path={`/admin/fields/${scheme.identifier}`}
                      deep={3}
                      permission={'storage.objectScheme.store'}
                    />
                  </NavItem>
                ))}

              {showFetchMoreButton && (
                <Box px={6}>
                  <Button
                    disabled={loadMoreAdminSchemesActionStatus.isPending}
                    onClick={handleFetchMoreSchemes}
                    sx={{ display: 'inline-block' }}
                  >
                    <Typography fontSize={12} color="inherit">
                      {t('showMore')}
                    </Typography>
                  </Button>
                </Box>
              )}
            </Stack>
          )}
        </Fade>
      </SwitchTransition>
    </Stack>
  )
}

export default SchemesAdminListNavigation
